import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "@material-ui/lab/TabPanel";
import { HorizontalTabsProps, TabType } from "./HortizontalTabs.types";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    position: "relative",
    width: "100%",
  },
  tabSection: {
    borderBottom: "none",
    position: "absolute",
    top: "-32px",
    zIndex: 9,
  },
  tab: {
    border: "1px solid rgba(226, 229, 230, 0.35)",
    backgroundColor: "#FFFFFF",
    color: "#737B7D",
    minHeight: "5px",
    height: "33px",
    minWidth: "130px",
    boxSizing: "border-box",
    borderRadius: "4px 4px 0px 0px",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: "14px",
    fontWeight: "600" as any,
    lineHeight: "22px",
    letterSpacing: "0.1px",
    textTransform: "none",
  },
  tabPanel: {
    border: "1px solid rgba(226, 229, 230, 0.35)",
    padding: "0px",
    overflowY: "auto",

    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 16px rgba(55, 63, 65, 0.06)",
    borderRadius: "0px 4px 4px 4px",
  },
  selectedTab: {
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid white",
    color: "#373F41",
  },
}));

export const HorizontalTabs: React.FC<HorizontalTabsProps> = ({ tabs }) => {
  const classes = useStyles();
  const [tab, setTab] = React.useState(tabs[0].name);

  const handleChange = (event: React.ChangeEvent<{}>, newTab: string) => {
    setTab(newTab);
  };

  return (
    <div className={classes.root}>
      <TabContext value={tab}>
        <AppBar position="static">
          <Tabs
            onChange={handleChange}
            value={tab}
            className={classes.tabSection}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            {tabs.map((tab: TabType) => (
              <Tab
                classes={{ root: classes.tab, selected: classes.selectedTab }}
                label={tab.name}
                value={tab.name}
                key={tab.name}
              />
            ))}
          </Tabs>
        </AppBar>
        {tabs.map((tab: TabType) => (
          <TabPanel
            className={classes.tabPanel}
            value={tab.name}
            key={tab.name}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};
